const $         = require('jquery');
const _         = require('underscore');
const { icon }  = require('@fortawesome/fontawesome-svg-core');
const tpl       = require('../util/template');
const ellipsis  = require('../util/ellipsis');
const evtbus    = require('../evtbus');
const evtout    = require('../evtout');

const faIconOpts = { classes: ['fa-icon'] };
const fa = {
  fileVideo: require('@fortawesome/pro-duotone-svg-icons/faFileVideo').definition,
  playCircle: require('@fortawesome/pro-duotone-svg-icons/faPlayCircle').definition
};

function compile({ videos }) {
  if (!videos.length) {
    return $('<div class="video-list"></div>');
  }

  const elem = $(`
    <div class="video-list">
      ${videos.sort((a, b) => a.index - b.index).map((video, index) => {
        return `
          <div class="video" idx="${index}">
            <div class="view-video">
              <img class="thumb" draggable="false" src="${video.thumb && video.thumb[0]}" alt/>
              ${icon(fa.fileVideo, faIconOpts).html}
              ${icon(fa.playCircle, faIconOpts).html}
            </div>
            <span class="description" data-tippy-content="${ellipsis(video.description, 1021)}">
              <b>${video.caption}<span> (${video.type.toUpperCase()})</span></b>
              ${tpl.if(video.description, () => `
                <span><b> | </b>${video.description}</span>
              `)}
            </span>
          </div>`;
      }).join('')}
    </div>
  `);

  elem.find('.video').each(function(index) {
    let video = videos[index];
    let thumb = video.thumb;
    if (thumb && thumb[0]) {
      let img = new Image();
      img.onload = () => setProcessed.call(this, 'true');
      img.onerror = () => setProcessed.call(this, 'false');
      img.src = thumb[0];
    } else {
      setProcessed.call(this, 'false');
    }

    $(this).click(() => {
      if (video.url) {
        evtbus.trigger('play-video', [index, videos]);
      } else {
        evtout.trigger('open-supplement', [video]);
      }
    })
  });

  function setProcessed(value) {
    $(this).attr('processed', value);
  }

  return elem;
}

module.exports = { compile };
